import { threadsService } from "@services/chatBackend";
import type {
  ThreadMessagesResponse,
  ThreadsResponse
} from "@services/chatBackend/models";
import type { ChatMessagesPage, ChatThreadsPage } from "./models";
import {
  DEFAULT_MESSAGES_PAGE_SIZE,
  DEFAULT_THREADS_PAGE_SIZE
} from "./config";

export async function fetchChatThreads(
  page: number,
  limit: number = DEFAULT_THREADS_PAGE_SIZE
): Promise<ChatThreadsPage> {
  const response: ThreadsResponse = await threadsService.getThreads(page, limit);

  return {
    threads: response.threads.map((t) => ({
      id: t.thread_id,
      title: t.title,
      createdAt: t.created_at,
      updatedAt: t.updated_at
    })),
    page: response.pagination.page,
    limit: response.pagination.limit
  };
}

export async function fetchChatThreadMessages(
  threadId: string,
  page: number,
  limit: number = DEFAULT_MESSAGES_PAGE_SIZE
): Promise<ChatMessagesPage> {
  const response: ThreadMessagesResponse =
    await threadsService.getThreadMessages(threadId, page, limit);

  return {
    messages: response.messages.map((m) => ({
      role: String(m.role ?? ""),
      content: String(m.content ?? ""),
      timestamp: String(m.timestamp ?? ""),
      ...m
    })),
    page: response.pagination.page,
    limit: response.pagination.limit
  };
}

